import axios from "axios";
import { tmsApi } from "../api";

export const getDriverList = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(
        tmsApi +
        `v1/entities/finddriverbyservicecity/${obj.serviceCityId}?page=${obj.page}&size=${obj.size}`,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const deleteDriver = async (id) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .delete(tmsApi + `v1/entities/driver/${id}`, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const retrieveDriver = async (id) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/entities/recover/driver/${id}`, {}, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const rechargeDriver = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/services/driverWalletTransaction`, obj, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriversByName = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi + `v1/entities/driver/search/byname`,
        {
          fullName: obj.inputValue,
          serviceCityId: obj.serviceCityId,
        },
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverListCount = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/entities/trip_count`, obj, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverTrips = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/trip/history/driver/${obj.driverId}`, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const driverDocumentDownload = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(
        tmsApi +
        `v1/entities/driver/documents/download?key=${obj.key}&fileName=${obj.fileName}&driverId=${obj.driverId}&isEverything=false`,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getAssignDriverList = async (obj) => {
  console.log(obj, "objiss");
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    if (obj.pickupType == "AirportToCity" && obj.driverType == "Active") {
      return axios
        .get(
          tmsApi +
          `v1/services/dispatcherdashboard/findairportdriver/${obj.bookingId}`,
          config
        )
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } else if (
      (obj.pickupType == "CityToAirport" || obj.pickupType == "CityToCity") &&
      obj.driverType == "Active"
    ) {
      return axios
        .get(
          tmsApi +
          `v1/services/dispatcherdashboard/finddriver/${obj.bookingId}`,
          config
        )
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } else if (obj.driverType == "OnTrip") {
      return axios
        .get(
          tmsApi +
          `v1/services/dispatcherdashboard/findontripdriver/${obj.bookingId}`,
          config
        )
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } else if (obj.driverType == "Inactive") {
      return axios
        .get(
          tmsApi +
          `v1/services/dispatcherdashboard/findlogoutdriver/${obj.bookingId}`,
          config
        )
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } else if(obj.driverType === "Assigned"){
      return axios
        .get(
          tmsApi +
          `v1/services/dispatcherdashboard/findassigneddriver/${obj.bookingId}`,
          config
        )
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    }
  } catch (error) {
    console.log("error", error);
  }
};

export const getCarCurrentIdbyDriver = (driverId) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/driver/currentcarstatusid/${driverId}`, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const assignDriverToBooking = (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi + `v1/services/dispatcherdashboard/assigndriver`,
        obj,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getManualBookings = (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/entities/manualassign/booking`, obj, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverPayments = (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/driver/payments/16710`, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverWallet = (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi +
        `v1/entities/driver/earnings?page=${obj.page}&size=${obj.size}`,
        {
          id: obj.driverId,
        },
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverRechargeTransactions = (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi +
        `v1/entities/driver/transactions?page=${obj.page}&size=${obj.size}`,
        {
          driverId: obj.driverId,
          transactionType: "Recharge",
        },
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverSFEETransactions = (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi +
        `v1/entities/driver/transactions?page=${obj.page}&size=${obj.size}`,
        {
          driverId: obj.driverId,
          transactionType: "DailySubscription",
        },
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverCollectionAmounts = (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi +
        `v1/entities/driver/trips/collectable?page=${obj.page}&size=${obj.size}`,
        {
          fromDate: obj.fromDate,
          toDate: obj.toDate,
          id: obj.driverId,
        },
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverWalletCount = (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/driver/earnings/count/${obj.driverId}`, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverBalance = (driverId) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/driver/balance/${driverId}`, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverLastLocation = (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi +
        `v1/entities/driver/trip/locate/${obj.driverId}/0/${obj.carNo}`,
        obj,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const postNotifyDriver = (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/entities/driver/custom/notification`, body, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverBlockReasons = (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/driver/blocked/list`, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const blockDriver = (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/entities/driver/block/unblock`, obj, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const resetDriverLogin = (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/entities/driver/reset/${obj.mobile}`, obj, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
    return error
  }
};

export const getDriverTableFilterData = async (obj, body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi + `v1/entities/driver/filter?page=${obj.page}&size=${obj.size}`,
        body,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverTableSearchData = async (obj, body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi + `v1/entities/driver/search?page=${obj.page}&size=${obj.size}`,
        body,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverTypes = async () => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + "v1/entities/drivertype", config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error;
  }
};

export const getDriverDataByBookingNumber = async (body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "text/plain",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/entities/trip/driver/details`, body, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverInventoryList = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(
        tmsApi +
        `v1/entities/carcurrentstatus/servicecity/${obj.serviceCityId}?page=${obj.page}&size=${obj.size}`,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverInventoryListCount = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(
        tmsApi + `v1/entities/carcurrentstatus/count/${obj.serviceCityId}`,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getInventoryTableFilterData = async (obj, body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi +
        `v1/entities/carcurrentstatus/filter/new?page=${obj.page}&size=${obj.size}`,
        body,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getInventoryTableSearchData = async (obj, body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi +
        `v1/entities/carcurrentstatus/search?page=${obj.page}&size=${obj.size}`,
        body,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverDeduction = async (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .get(tmsApi + `v1/entities/driverdeductiontype/${obj.driverTypeId}/${obj.serviceCityId}`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverDeductionSearch = async (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .get(tmsApi + `v1/entities/driverdeductiontype/search/${obj.key}`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const createDeductionType = (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .post(tmsApi + "v1/entities/driverDeductionType/create", obj, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverDeductionById = (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .get(tmsApi + `v1/entities/driverDeductionTypes/${obj.id}`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverDeductionByAll = (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .get(tmsApi + `v1/entities/driverDeductionTypes`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const updateDriverDeduction = (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .put(tmsApi + `v1/entities/driverDeductionType/update`, obj, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverSchemes = () => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + `v1/entities/drivertype`, config).then((resp) => {
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverTypeTable = (serviCityId) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + `v1/entities/minimumwalletbalance/all/${serviCityId}`, config).then((resp) => {
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverTypeAllCity = () => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + `v1/entities/minimumwalletbalance/all`,config).then((resp) => {
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const updateDriverScheme = (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .put(tmsApi + `v1/entities/drivertype/updated`, obj, config)
      .then((resp) => {
        return resp;
      });
  } catch
  (error) {
    console.log("error", error);
  }
};

export const createDriverScheme = (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .post(tmsApi + "v1/entities/drivertype/create", obj, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverSchemeById = (driverSchemId)=>{
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .get(tmsApi + `v1/entities/drivertype/${driverSchemId}`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
}

export const getSchemeDeductionsAll =  (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .get(tmsApi + `v1/entities/driverSchemes/${obj.serviceCityId}/${obj.driverTypeId}/${obj.deductionTypeId}`, config)
      .then((resp) => {
        // console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const createSchemeDeduction = (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  return axios
    .post(tmsApi + "v1/entities/driverSchemes/create", obj, config)
    .then((resp) => {
      return resp;
    });
};

export const getSchemeDeductionsById = (schemeDeductionId) =>{
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .get(tmsApi + `v1/entities/driverSchemes/deductions/${schemeDeductionId}`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
}

export const deletSchemeDeductions =(obj)=>{
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .delete(tmsApi + `v1/entities/drivertype/deduction/${obj.schemeDeductionId}?isDeleted=${obj.isDeleted}`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
}

export const updateSchemeDeduction = async(obj) => {

  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  return axios.put(tmsApi+"v1/entities/driverSchemes/update",obj,config).then((resp)=>{
    return resp;
  })

};

export const getAllDriverSchemeDeduction=async(obj)=>{
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  return axios
    .post(tmsApi + `v1/entities/driverSchemes/${obj.serviceCityId}?page=${obj.page}&size=${obj.size}`, config)
    .then((resp) => {
      return resp;
    });
}

export const searchSchemeDeductions =(obj)=>{
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios.get(tmsApi + `v1/entities/driverSchemes/${obj.serviceCityId}/${obj.key}?page=${obj.page}&size=${obj.size}`,config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
}

export const getWalletAll=async(obj)=>{
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios
    .get(tmsApi + `v1/entities/minimumwalletbalance/drivertype/servicecity/${obj.driverSchemeId}/${obj.serviceCityId}`, config)
    .then((resp) => {
      return resp;
    });
}

export const getWallet=async(id)=>{
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios
    .get(tmsApi + `v1/entities/minimumwalltebalance/${id}`, config)
    .then((resp) => {
      return resp;
    });
}

export const getDriverTypeWalletAllSearch=async(obj)=>{
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  return axios
    .get(tmsApi + `v1/entities/minimumwalltebalance/search/${obj.key}/${obj.serviceCityId}`, config)
    .then((resp) => {
      return resp;
    });
}


export const updateWallet=(obj)=>{
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  return axios
    .put(tmsApi + "v1/entities/minimumwalltebalance/update",obj, config)
    .then((resp) => {
      return resp;
    });
}

export const createWallet =(obj)=>{
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  return axios
    .post(tmsApi + "v1/entities/minimumwalltebalance/create",obj, config)
    .then((resp) => {
      return resp;
    });
}

export const deleteDriverType = async(obj)=>{
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  }

  return axios.delete(tmsApi + `v1/entities/drivertype/${obj.driverTypeId}?isDeleted=${obj.isDeleted}`,config)
    .then((resp) => {
      return resp;
    })
}



export const deleteDriverScheme=async(obj)=>{
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  return axios
    .delete(tmsApi + `v1/entities/drivertype/${obj.schemeId}?isDeleted=${obj.isDeleted}`, config)
    .then((resp) => {
      return resp;
    });
}

export const PostDriverApplyLeave = (obj) => {

  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(

        tmsApi +
          `v1/entities/driver/apply/leave`,
        obj,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const GetDriverAttendanceList=async(obj)=>{
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
  return axios
    .get(tmsApi + `v1/entities/driver/leave/${obj.id}`, config)
    .then((resp) => {
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
}



export const assignVendorToBooking = (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi + `v1/entities/aggregator/assign`,
        obj,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};
export const getAssignVendorList = async () => {
  console.log("vendor list get");

  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {

    return axios
      .get(
        tmsApi + `v1/entities/aggregatoralllist`,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });

  } catch (error) {
    console.log("error", error);
  }
};
export const getAssignVendorListBasedOnVendorType = async (obj) => {
  console.log("vendor list get");

  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {

    return axios
      .get(
        tmsApi + `v1/entities/aggregator/active/inactive/`+obj.serviceCityId+"/"+obj.status,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });

  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverSchemeDetails = async (id) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/drivertype/schemedetails/${id}`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const updateDriverSchemeDetails = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .put(tmsApi + `v1/entities/drivertype/schemedetails`, obj, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};
export const createDriverSchemeDetails = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/entities/drivertype/schemedetails`, obj, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const saveBulkDriverDeductions = async (list) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/entities/drivertype/deductions/bulk`, list, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const updateDriverTypeDeduction = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .put(tmsApi + `v1/entities/drivertype/deduction`, obj, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getDriverTypeDeductions = async (driverTypeId, serviceCityId) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(tmsApi + `v1/entities/drivertype/deductions/${driverTypeId}/${serviceCityId}`, config)
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};
